import type { HelpFile } from '../../types/help'
import { SqlEditorTestIds } from '../../../testids/SqlEditorTestIds'

export const sqlEditorHelp: HelpFile = {
  docPage: '/docs/admin/sql-editor',
  texts: {
    [SqlEditorTestIds.sqlEditor]:
      'Compose a SQL query against the read-only reporting view. Use this to validate query shape and parameters before saving the report definition.',
    [SqlEditorTestIds.sqlEditorTextarea]:
      'Write your SQL here. Bind parameters with `:name` placeholders — they map to the report parameter list.',
  },
}
